<template>
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    ...attributes
  >
    <circle stroke="currentColor" cx="11" cy="11" r="8"></circle>
    <line stroke="currentColor" x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
</template>
